export default {
  all: state => {
    return state.all
  },
  single: state => {
    return state.single
  },
  batchEmails: state => state.batchEmails
}
